/**
 * @description
 */
"use strict";
const env = process.env.NODE_ENV;


module.exports = {}


// WEBPACK FOOTER //
// src/config/index.js